// extracted by mini-css-extract-plugin
module.exports = {"FormHorizontalSpace":"FormHorizontalSpace_FormHorizontalSpace__1PS8Y","medium":"FormHorizontalSpace_medium__2r6Jc"};